import { z } from 'zod';

export const ZodTrimmedString = z.string().trim();
